import * as FastBookingActions from './fast-booking.actions';
export { FastBookingActions };
